import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Card } from "@/components/Ui";
import { WhatsAppSendDialog } from "@/components/WhatsAppSendDialog";
import { WhatsAppChat } from "@/components/WhatsAppChat";

function PersonRow({ p, active, unread, onClick }) {
  const why = !p.wa_id ? "cellulare mancante" : !p.consent ? "consenso non registrato" : p.window_open ? "finestra 24 ore aperta" : null;
  return (
    <li>
      <button onClick={onClick} data-testid={`wa-recipient-${p.subject_id}`}
        className={`w-full text-left px-4 py-3 flex items-center gap-3 transition-colors ${active ? "bg-emerald-50" : "hover:bg-slate-50"}`}>
        <span className="h-9 w-9 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-sm font-semibold shrink-0">{p.name.slice(0, 1)}</span>
        <span className="flex-1 min-w-0">
          <span className="block text-sm text-slate-900 truncate">{p.name}</span>
          <span className="block text-[11px] text-slate-500 truncate">{p.role}{why ? ` · ${why}` : ""}</span>
        </span>
        {unread > 0 && <span className="min-w-[20px] h-5 px-1.5 rounded-full bg-emerald-600 text-white text-[11px] font-semibold flex items-center justify-center" data-testid={`wa-unread-${p.subject_id}`}>{unread}</span>}
      </button>
    </li>
  );
}

export function WhatsAppPanel({ trust }) {
  const [params] = useSearchParams();
  const [status, setStatus] = useState(null);
  const [people, setPeople] = useState([]);
  const [unread, setUnread] = useState({});
  const [sel, setSel] = useState(params.get("subject"));
  const [tplFor, setTplFor] = useState(null);

  const loadPeople = useCallback(() => {
    api.get("/whatsapp/recipients", { params: { trust_id: trust.id } }).then((r) => setPeople(r.data)).catch(() => {});
    api.get("/whatsapp/unread", { params: { trust_id: trust.id } }).then((r) => setUnread(r.data)).catch(() => {});
  }, [trust.id]);
  useEffect(() => { api.get("/whatsapp/status").then((r) => setStatus(r.data)).catch(() => {}); loadPeople(); }, [loadPeople]);
  useEffect(() => { if (!sel && people.length) setSel(people[0].subject_id); }, [people, sel]);
  if (!status) return null;
  const person = people.find((p) => p.subject_id === sel);

  return (
    <div className="space-y-4" data-testid="wa-panel">
      {!status.configured && <Card className="p-4 text-sm text-amber-800" data-testid="wa-not-configured">WhatsApp non ancora configurato: l'Amministratore deve completare l'area Collegamenti tecnici.</Card>}
      <Card className="overflow-hidden grid md:grid-cols-[280px_1fr]">
        <div className="border-b md:border-b-0 md:border-r border-slate-100">
          <p className="px-4 py-3 font-heading font-semibold text-slate-900 flex items-center gap-2 border-b border-slate-100"><MessageCircle className="h-4 w-4 text-emerald-600" />Conversazioni</p>
          {!people.length && <p className="px-4 py-6 text-sm text-slate-400">Nessun soggetto collegato al Trust</p>}
          <ul className="max-h-[470px] overflow-y-auto">
            {people.map((p) => <PersonRow key={p.subject_id} p={p} active={p.subject_id === sel} unread={p.subject_id === sel ? 0 : unread[p.subject_id] || 0} onClick={() => setSel(p.subject_id)} />)}
          </ul>
        </div>
        {person
          ? <WhatsAppChat key={person.subject_id} trust={trust} person={person} onTemplate={() => setTplFor(person)} onActivity={loadPeople} />
          : <p className="p-10 text-center text-sm text-slate-400">Seleziona un cliente</p>}
      </Card>
      {tplFor && <WhatsAppSendDialog trust={trust} person={tplFor} onClose={(ok) => { setTplFor(null); if (ok) loadPeople(); }} />}
    </div>
  );
}
